
















import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class AppLightModal extends Vue {
  @Prop({ type: String, default: 'white' }) readonly bg!: string;
  @Prop({ type: Boolean, default: false }) readonly fixed!: boolean;
  @Prop({ type: [Number], default: 48 }) readonly top!: number;

  @Emit('hide')
  hide () {
    // do nothing
  }
}
